module.exports = __webpack_public_path__ + "img/anno1800wallpaper.576b1e72.jpg";